export default __webpack_public_path__ + "static/media/bomb_2.462f5429.jpg";